var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 24.75C28.2594 24.75 28.875 24.1344 28.875 23.375C28.875 22.6156 28.2594 22 27.5 22H5.5C4.74061 22 4.125 22.6156 4.125 23.375C4.125 24.1344 4.74061 24.75 5.5 24.75H27.5ZM27.5 17.875C28.2594 17.875 28.875 17.2594 28.875 16.5C28.875 15.7406 28.2594 15.125 27.5 15.125H5.5C4.74061 15.125 4.125 15.7406 4.125 16.5C4.125 17.2594 4.74061 17.875 5.5 17.875H27.5ZM4.125 9.625C4.125 10.3844 4.74061 11 5.5 11H27.5C28.2594 11 28.875 10.3844 28.875 9.625C28.875 8.86561 28.2594 8.25 27.5 8.25H5.5C4.74061 8.25 4.125 8.86561 4.125 9.625Z",
    fill: "#C2D1D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_556_2561",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 25,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 24.75C28.2594 24.75 28.875 24.1344 28.875 23.375C28.875 22.6156 28.2594 22 27.5 22H5.5C4.74061 22 4.125 22.6156 4.125 23.375C4.125 24.1344 4.74061 24.75 5.5 24.75H27.5ZM27.5 17.875C28.2594 17.875 28.875 17.2594 28.875 16.5C28.875 15.7406 28.2594 15.125 27.5 15.125H5.5C4.74061 15.125 4.125 15.7406 4.125 16.5C4.125 17.2594 4.74061 17.875 5.5 17.875H27.5ZM4.125 9.625C4.125 10.3844 4.74061 11 5.5 11H27.5C28.2594 11 28.875 10.3844 28.875 9.625C28.875 8.86561 28.2594 8.25 27.5 8.25H5.5C4.74061 8.25 4.125 8.86561 4.125 9.625Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_556_2561)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2bd854b2f38e35b560dbc78d5f983d3b.svg";
export { ForwardRef as ReactComponent };